import { AxiosResponse } from 'axios';
import { Service } from 'typedi';
import { axios } from '../axios';
import { ShowNotification } from '../ShowNotification';
import { IAdminSettingResponse, IAdminSettingsResponse } from '../../types';

@Service()
export class AdminRequest {
  
  @ShowNotification()
  getAllAdminSettings(): Promise<AxiosResponse<IAdminSettingsResponse>> {
    return axios.get('/setting/admin/all');
  }

  @ShowNotification()
  getAdminSetting(setting: string): Promise<AxiosResponse<IAdminSettingResponse>> {
    return axios.get(`/setting/admin?type=${setting}`)
  }
}
